exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".requests-table .ant-table-row.confirmed-row {\n  background-color: white;\n}\n.requests-table .ant-table-row.cleaned-row {\n  background-color: #ecfceb;\n}\n.requests-table .ant-table-row.canceled-row {\n  background-color: #f7f7f5;\n}\n", ""]);

